import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface InfoProps {
  $full: boolean;
  $mini: boolean;
}

export const Info: any = styled.ul<InfoProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ $full, $mini }) => ($full || $mini ? 'space-between' : 'flex-start')};
  box-sizing: border-box;
  margin: 0;
  width: ${({ $full }) => ($full ? '100%' : 'auto')};
`;

Info.Item = styled.li<InfoProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${({ $full, $mini }) => ($full || $mini ? '0 4px 0 0' : '0 10px 0 0')};
  & span {
    font-size: ${({ $mini }) => ($mini ? '11px' : '12px')};
    color: ${ColorPalette.HEX.PineTree};
  }
  & img {
    margin-right: ${({ $mini }) => ($mini ? '2px' : '5px')};
    width: ${({ $mini }) => ($mini ? '12px' : '16px')};
  }
`;

Info.Icon = styled.img`
  font-size: 12px;
`;

Info.Type = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
